(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-collection-toolbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.rm-ctb__sort-select')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-product-ingredients"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-rm-label-link]');
  if (!link) return;
  const gallery = document.getElementById(link.hash.slice(1));
  if (!gallery) return;
  const thumbnail = Array.from(gallery.querySelectorAll('.gallery__thumbs button')).find((button) =>
    (button.dataset.src || '').split('?')[0].split('/').pop() === link.dataset.labelFile
  );
  if (thumbnail) thumbnail.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-proof-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rm-proof-library')) {
    customElements.define('rm-proof-library', class extends HTMLElement {
      connectedCallback() {
        const filters = this.querySelector('[data-proof-filters]');
        if (!filters || filters.dataset.initialized) return;
        const cards = Array.from(this.querySelectorAll('[data-proof-card]'));
        const categories = [...new Set(cards.map(card => card.dataset.category).filter(Boolean))];
        if (categories.length < 2) return;
        categories.forEach(category => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rm-proof__filter';
          button.dataset.proofFilter = category;
          button.setAttribute('aria-pressed', 'false');
          button.textContent = category;
          filters.appendChild(button);
        });
        filters.hidden = false;
        filters.dataset.initialized = 'true';
        filters.addEventListener('click', event => {
          const button = event.target.closest('[data-proof-filter]');
          if (!button || !filters.contains(button)) return;
          filters.querySelectorAll('[data-proof-filter]').forEach(filter => {
            filter.setAttribute('aria-pressed', String(filter === button));
          });
          cards.forEach(card => {
            card.hidden = Boolean(button.dataset.proofFilter) && card.dataset.category !== button.dataset.proofFilter;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
